<template>
    <nav class="sidebar" :class="{'sidebar--open': isNavigationOpen}">
        <button class="navigation-toggle" @click="toggleNavigation"><i class="fa fa-times"></i></button>
        <div class="sidebar__top">
            <h1 class="sidebar__title">SNF Redaktionstool</h1>
            <h2 class="sidebar__greeting">Hallo {{user.givenName}} {{user.familyName}}</h2>
        </div>
      <div v-if="language != 'de'" class="alert alert-danger">
        ACHTUNG: Du bearbeitest nicht auf Deutsch, bitte aufpassen!
      </div>

        <ul class="sidebar__middle navigation no-list">
            <router-link to="/" tag="li"><a class="navigation__link">Projekte</a></router-link>
            <router-link to="/umbrella_projects" tag="li"><a class="navigation__link">Verbundprojekte</a></router-link>
            <router-link to="/results" tag="li"><a class="navigation__link">Allgemeine Resultate</a></router-link>
            <router-link to="/infoboxes" tag="li"><a class="navigation__link">Infoboxen</a></router-link>
            <router-link to="/partners" tag="li"><a class="navigation__link">Partner</a></router-link>
            <router-link to="/key_themes" tag="li"><a class="navigation__link">Themenschwerpunkte</a></router-link>
            <router-link to="/dossiers" tag="li"><a class="navigation__link">Dossiers</a></router-link>
            <router-link to="/program_resumee" tag="li"><a class="navigation__link">Programm Resümee</a></router-link>
            <router-link to="/tags" tag="li"><a class="navigation__link">Tags</a></router-link>
            <router-link to="/users" tag="li"><a class="navigation__link">Benutzer</a></router-link>
        </ul>
        <hr>
        <div class="form-group">
            <label>Bearbeitungssprache</label>
            <select class="form-control" :value="language" @change="changeLanguage">
                <option value="de">Deutsch</option>
                <option value="fr">Französisch</option>
                <option value="en">Englisch</option>
            </select>
        </div>

        <br>
        <ul class="sidebar__bottom navigation no-list">
            <!--
            <router-link to="/" tag="li"><a class="navigation__link">Profil</a></router-link>
            -->
            <a href="#" class="navigation__link" @click.prevent="clearCache">Cache leeren</a>
            <a href="#" class="navigation__link" @click.prevent="clearExportCache">Export Cache leeren</a>
            <a href="#" class="navigation__link" @click.prevent="searchIndex">Suchindex erstellen</a>
            <a href="#" class="navigation__link" @click.prevent="logout">Logout</a>
        </ul>
    </nav>
</template>
<script>
export default {
  computed: {
    user() {
      return store.state.user;
    },
    isNavigationOpen() {
      return store.state.isNavigationOpen;
    },
    language() {
      return store.state.language;
    }
  },
  methods: {
    clearCache() {
      axios.post("/api/cache/clear").then(({ data }) => {
        console.log(data)
        alert("Done!")
      });
    },
    clearExportCache() {
      axios.post("/api/en/export_service/clear_cache").then(({ data }) => {
        console.log(data)
        alert("Done!")
      });
    },
    searchIndex() {
      alert("This could take a while...");
      axios.post("/api/en/search/rebuild").then(({ data }) => {
        console.log(data)
        alert("Done!")
      });
    },
    toggleNavigation() {
      store.commit("toggleNavigation");
    },
    changeLanguage($event) {
      localStorage.setItem("language", $event.target.value);
      location.reload();
    },
    logout() {
      axios.post(logoutUrl).then(({ data }) => {
        location.reload();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue